<template>
    <div>
      <div class="details-banner" v-if="!bannerImg"></div>
      <a :href="!!bannerPath && bannerPath" class="block" style="height: 500px">
        <img
          :src="bannerImg"
          style="
            width: 100%;
            margin-top: 64px;
            height: 500px;
            overflow: hidden;
            object-fit: cover;
          "
          v-if="sourceType === 'img' && bannerImg"
        />
        <video
          id=""
          autoplay
          muted
          loop
          preload="auto"
          style="z-index: 200; width: 100%; height: auto; margin-top: 64px"
          v-if="sourceType === 'video' && video"
        >
          <source type="video/mp4" src="../assets/images/Rectangle.png" />
        </video>
        <div
          class="product-container m-auto main-p"
          style="
            position: absolute;
            left: 50%;
            top: 64px;
            transform: translate(-50%, 0%);
            z-index: 300;
          "
        >
          <div style="width: 100%; position: relative; top: 73px">
            <div
              style="
               
                font-size: 40px;
                font-weight: 500;
                line-height: 52px;
                text-align: left;
                color: #333333;
                margin-bottom: 16px;
              "
            >
              {{ titleData.title }}
            </div>
            <div
              style="
               
                font-size: 16px;
                font-weight: 400;
                line-height: 28px;
                text-align: left;
                color: #666666;
                margin-bottom: 40px;
              "
            >
              {{ titleData.subTitle }}
            </div>
            <div
              style="
                width: 140px;
                height: 44px;
                padding: 11px 27px;
                gap: 8px;
                background: #d7000f;
                cursor: pointer;
              "
              @click="consultOpen = true"
            >
              <img src="../assets/images/talk.png" alt="" style="width: 18px" />
              <span
                style="
                  color: #fff;
                  text-align: center;
                 
                  font-size: 14px;
                  font-style: normal;
                  font-weight: 600;
                  line-height: normal;
                "
                >立即咨询</span
              >
            </div>
          </div>
          <div
            class="m-auto hidden lg:block"
            style="
              width: 1280px;
              height: 230px;
              background: #fff;
              margin-top: 165px;
              overflow: hidden;
              border: 2px solid var(--Color-2, #fff);
              background: linear-gradient(0deg, #fff 0%, #fffbfb 100%);
              box-shadow: 0px 5px 18px 0px rgba(40, 41, 61, 0.07);
              padding: 20px;
            "
          >
            <div
              style="
                height: 16px;
                width: 4px;
                gap: 0px;
                opacity: 0px;
                background: #d7000f;
                float: left;
                margin-right: 10px;
                margin-top: 4px;
              "
            ></div>
            <div
              style="
               
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                text-align: left;
                color: #000000;
                margin-bottom: 20px;
              "
            >
              热门产品
            </div>
            <div class="contantOther">
              <div
                style="
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: space-between;
                "
              >
                <div
                  style="width: 392px"
                  v-for="(child, childIndex) in listTitle"
                  :key="childIndex"
                >
                  <div class="box" @click="handleDetailsClick(child)">
                    <div class="label">
                      {{ child.productTitle }}
                      <div>热门</div>
                    </div>
                    <div class="desc hidden-3">
                      <show-overf-low-tooltip>
                        {{ child.productIntroduction }}
                      </show-overf-low-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
  
      <div
        class="product-container detail_container"
        style="margin-top: 180px; margin-bottom: 100px"
      >
        <aside>
          <div>
            <h5 style="margin-bottom: 24px; color: #333">产品分类</h5>
            <el-menu
              default-active="0"
              class="el-menu-vertical-demo"
              style="border: none"
            >
              <el-menu-item
                v-for="(item, index) in list"
                :key="index"
                :index="index.toString()"
                :class="{ activities: cur == index }"
                @click="handleClick(index) || scrollToId(index.toString())"
              >
                <span slot="title">{{ item.dictLabel }}</span>
              </el-menu-item>
            </el-menu>
          </div>
        </aside>
        <main class="contant">
          <div v-for="(item, index) in list" :key="index" v-show="cur == index">
            <el-row :gutter="20">
              <el-col
                v-for="(child, childIndex) in item.serviceList"
                :key="childIndex"
                :xs="24"
                :sm="8"
                :lg="8"
              >
                <div class="box activities" @click="handleDetailsClick(child)">
                  <div style="display: flex; justify-content: space-between">
                    <div class="label hidden-1" style="display: inline-block">
                      {{ child.productTitle }}
                    </div>
                    <div
                      class="sp"
                      style="
                        display: none;
                        color: rgb(215, 0, 15);
                      "
                    >
                      →
                    </div>
                  </div>
                  <div class="desc">
                    <show-overf-low-tooltip>
                      {{ child.productIntroduction }}
                    </show-overf-low-tooltip>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <el-pagination
            style="text-align: center; margin-top: 60px"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :total="
              (this.list[this.active] || { serviceList: [] }).serviceList.length
            "
          />
        </main>
      </div>
  
      <consult
        v-if="consultOpen"
        title="立即咨询"
        :dialogVisible="consultOpen"
        productId="0"
        @cancel="consultOpen = false"
      >
      </consult>
      <div  v-if="showButton" class="to-top" @click="totop()">
      <img src="../assets/images/totop.png" alt="" />
    </div>
    </div>
  </template>
  
  <script>
  import { listProductAll, listBanner } from "@/api";
  
  export default {
    name: "ProductDetails",
    data() {
      return {
          // 返回顶部按钮
      showButton: false,
        active: 0,
        list: [],
        cur: "",
        pageSize: 100,
        sourceType: "img",
        bannerImg: "",
        video: "",
        bannerPath: "",
        titleData: {},
        listTitle: [],
        consultOpen: false,
      };
    },
      beforeDestroy() {
    window.removeEventListener('scroll',  this.handleScroll);  
  },
   mounted() {
  window.addEventListener('scroll',  this.handleScroll);  
   },
    created() {
      this.getList();
      this.getBanner();
    },
    methods: {
      totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
      handleScroll() {
      this.showButton  = window.scrollY  > 200; 
    },
      handleCurrentChange(number) {
        const start = (number - 1) * this.pageSize;
        this.page = this.list[this.active].serviceList.slice(
          start,
          start + this.pageSize
        );
      },
      handleClick(i) {
        this.cur = i;
      },
      scrollToId(targetId) {
        const targetElement = document.getElementById("chapter_" + targetId);
        if (!targetElement) return;
  
        const scrollTop = window.scrollY;
        const targetTop = targetElement.offsetTop;
  
        window.scrollTo({ top: targetTop - scrollTop, behavior: "smooth" });
      },
      async getBanner() {
        const res = await listBanner({ bannerPosition: "CPFW_BANNER" });
        res.rows.map((item) => {
          this.titleData.title = item.bannerPositionName;
          this.titleData.subTitle = item.subTitle;
        });
        const data = res.rows.find(
          (v) =>
            (v.bannerImg && v.sourceType == "img") ||
            (v.video && v.sourceType == "video")
        );
        if (!data) return;
        console.log(data);
        this.sourceType = data.sourceType;
        this.bannerImg = data.bannerImg;
        this.video = data.video;
        this.bannerPath = data.link;
      },
      async getList() {
        const res = await listProductAll({ useFlag: "1", moduleSort: "1" });
        this.list = res.data;
  
        res.data.forEach((item) => {
          item.serviceList.forEach((item2) => {
            if (item2.categoryLabel === "热门产品") {
              this.listTitle.push(item2);
            }
          });
        });
  
        if (this.listTitle.length < 6) {
          this.listTitle = JSON.parse(
            JSON.stringify(res.data[0].serviceList)
          ).splice(0, 6);
        }
  
        // this.listTitle = JSON.parse(JSON.stringify(res.data[0].serviceList)).splice(0, 6);
      },
      handlePositionClock(index) {
        this.active = index;
        this.$el.querySelector(`#id${index}`).scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "start",
        });
      },
      handleDetailsClick(item) {
        this.$router.push({
          path: "ProductDetails",
          query: { id: item.id, index: 1 },
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
  .main-p {
    display: inline-flex;
    max-width: 1280px;
  
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  
  .product-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  
    .product-head {
      width: 75%;
      margin-top: 50px;
      text-align: center;
  
      .product-head-title {
        display: inline-block;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        cursor: pointer;
        white-space: nowrap;
        margin-top: 10px;
      }
  
      .active {
        color: #e50009;
      }
    }
    .activities {
      display: block;
    }
    .tooltip-root {
          -webkit-line-clamp: 2 !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          white-space:initial !important
        }
    .contant {
      width: 100%;
      //margin: 70px 0;
  
      .contant-title {
        height: 45px;
        font-weight: 500;
        color: #000000;
        margin-bottom: 40px;
  
        :first-child {
          display: inline-block;
          width: 3px;
          height: 20px;
          background: #e50009;
          margin-right: 5px;
        }
  
        span {
          font-size: 32px;
        }
      }
  
      .box {
        //border: 1px solid #cccccc;
        width: 350px;
        height: 100px;
        padding: 15px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: 0.5s all;
        border: 2px solid var(--Color-2, #fff);
  
        .label {
         
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;
          text-align: left;
          margin-bottom: 9px;
          color: #333;
          display: inline-block;
        }
  .desc {
    .tooltip-root {
          -webkit-line-clamp: 2 !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
          display: -webkit-box !important;
          -webkit-box-orient: vertical !important;
          white-space:initial !important
        }
  }
       
      }
  
      .box:hover {
        background-image: url(../../static/img/display-img/show_new/bg_chanpin.png);
        background-repeat: no-repeat;
        background-position-y: center;
        border: 2px solid var(--Color-2, #fff);
        box-shadow: 0px 2px 37px 0px rgba(0, 39, 123, 0.06);
        .label {
          color: #e50009;
        }
        .sp {
          display: inline-block !important;
        }
      }
    }
  
    .contantOther {
      .box {
        height: 71px;
        width: 392px;
        gap: 9px;
        margin-bottom: 10px;
        cursor: pointer;
  
        .label {
         
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;
          text-align: left;
          margin-bottom: 9px;
          color: #333;
          display: inline-block;
  
          > div {
            display: inline-block;
            width: 40px;
            height: 22px;
            text-align: center;
            background: #f64041;
            border-radius: 2px 2px 2px 0px;
            color: #ffffff;
           
            font-size: 12px;
            font-weight: 400;
            margin-left: 8px;
          }
        }
  
        .desc {
          color: #666;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 20px;
          /* 166.667% */
        }
      }
  
      // .box:hover {
      //   box-shadow: 0px 4px 20px 0px rgba(204, 204, 204, 0.6);
  
      //   .label {
      //     color: #e50009;
      //   }
      // }
    }
  }
  
  .detail_container {
    //display: flex;
    //position: relative;
    //justify-content: center;
    //align-items: flex-start;
    //gap: 24px;
    //flex: 1 0 0;
    display: grid;
    grid-template-columns: 200px 1fr;
    grid-gap: 24px;
    margin: 0 auto;
  
    max-width: 1280px;
  
    aside {
      // > div {
      //   position: sticky;
      //   top: 200px;
      // }
  
      align-self: stretch;
  
      h5 {
        color: var(---333, #333);
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 140% */
      }
  
      >>> .el-menu-item {
        height: 44px;
        width: 100%;
        line-height: 44px;
        transition: none;
        // padding: 0 16px;
        span {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px; /* 150% */
        }
      }
  
      .el-menu-item.is-active {
        color: #d7000f;
        background: var(---f2f3f5-web, #f2f3f5);
  
        &:before {
          content: "";
          position: absolute;
          left: -3px;
          width: 3px;
          height: 100%;
          background: var(--xx, #d7000f);
        }
      }
      .el-menu-item:hover,
      .el-menu-item:focus {
        background: #fff;
      }
      .el-menu-item:focus {
        background: var(---f2f3f5-web, #f2f3f5);
      }
    }
  
    main {
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/chanpin.vue